import { route } from 'react-router-typesafe-routes/dom';
import { yup } from 'react-router-typesafe-routes/yup';
import * as Yup from 'yup';

export const AnalyticsRoutes = {
	ANALYTICS: route('analytics', {}),
};
